export default __webpack_public_path__ + "static/property-img-2-962e8de1f244688b15a605761181c66d.jpg";